// extracted by mini-css-extract-plugin
module.exports = {"wg8w20o":"wg8w20o","t19neper":"t19neper","sfq47zh":"sfq47zh"};